import styled, { css } from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const MaskWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  padding: ${({ renderMode }) => (renderMode === 'mobile' ? '4px' : '1px 4px')};
  justify-content: ${({ renderMode }) => (renderMode === 'preview' ? 'space-between' : 'flex-start')};
  gap: ${({ renderMode }) => (renderMode === 'mobile' ? '2px' : '0')};

  ${Styles.BorderStyles}
  height: ${({ renderMode, height }) => (renderMode === 'preview' ? height : 'auto')};
`;

export const MaskCharacter = styled.span`
  display: inline-flex;
  margin: 0 1px;
  justify-content: center;
  align-items: center;
  height: 16px;
  ${({ renderMode }) => renderMode === 'mobile' ? css`
    flex: 1; /* Grow and shrink equally to fill available space */
    min-width: 8px; /* Prevent characters from becoming invisibly small */
  ` : css`
    width: 10px; /* Keep fixed width for desktop preview */
    margin: 0 1px;
  `}

  /* Style the placeholder characters (e.g., '#') */
  background-color: ${({ isPlaceholder }) => (isPlaceholder ? '#cccccc' : 'transparent')};

  ${Styles.FontStyles}
  color: ${({ isPlaceholder, styleProps }) => (isPlaceholder ? 'transparent' : styleProps?.color)};
`;